<template lang="pug">
	.creatives-plane(v-if="Publisher.SelectedPublisher && Publisher.SelectedPublisher.id" :class="Layout.page" :style="{height: `calc(100% - ${Layout.subHeaderHeight}px)`, top: `${Layout.subHeaderHeight}px`}")
		.creatives-plane-inner(ref="scrollElement")
			.creative.add(v-if="Layout.page === 'banners' || Layout.page === 'end-cards' || Layout.page === 'storyboards' || Layout.page === 'editable-playables' || (Layout.page === 'playables' && Metadata.Config['feature-playable-templates'])")
				.creative-add-icon(v-on:click="addCreative()" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Create creative'}")
					i.fa.fa-plus
			.creative(v-for="creative in creatives" :key="creative.id" @mouseover="onCreativeOver(creative, $event)" @mouseout="onCreativeOut(creative, $event)")
				.creative-icon(:class="getCreativeIconClasses(creative)" :style="getCreativeIconStyles(creative)" v-on:click="Creative.selectCreative(creative.id)")
				.creative-online(v-if="Layout.isFeatureEnabled('online-users', 'online-users-project-plane')")
					OnlineUsersLocal(:filter="getFilterForOnlineUsers(creative.id)" max-count="3")
</template>

<script>
	import Screen from './../../mixins/screen'

	import { Publisher } from './../../services/Publisher'
	import { User } from './../../services/User'
	import { Creative } from './../../services/Creative'
	import { Layout } from './../../services/Layout'

	import OnlineUsersLocal		from './../../components/Header/OnlineUsersLocal';

	import SetupSettings from "./../../settings/settings.json";

	export default {
		name: 'CreativesPlane',
		mixins: [Screen],
		screen: {
			updateOn: ["Layout Workspace Changed", "Current User Changed", "Creative Changed", "Selected Creative Changed", "Creatives Icons Changed", "Selected Publisher Changed",
				"Creative Fully Loaded", "Creatives Filter Changed", "Current User Changed: [options.features]", "Users Online Status Changed", "User Online Status Changed", "User Online Status Added",
				"User Online Status Removed", "Layout Page Showed:banners", "Layout Page Showed:playables", "Layout Page Showed:end-cards", "Layout Page Showed:storyboards", "Layout Page Showed:editable-playables", "Layout Page Showed:marker", "Selected Creative Tags Changed",
				"Selected Creative Icon Changed", "Creative Icon Changed"],
			events: {

			}
		},
		components: {
			OnlineUsersLocal
		},
		data() {

			this.Publisher = Publisher;
			this.User = User;
			this.Creative = Creative;
			this.SetupSettings = SetupSettings;

			this.creatives = [];

			return {
				showed: true
			};
		},
		methods: {
			collectData() {

				this.creatives = Creative.getOrderedCreativesList(Publisher.SelectedPublisher, Layout.page, Layout.workspace, Layout.creativesFilter);

				if (this.$refs.scrollElement) {

					this.$refs.scrollElement.removeEventListener('scroll', this.dispatchScrollEvent);
					this.$refs.scrollElement.addEventListener('scroll', this.dispatchScrollEvent);

				}

			},
			getCreativeIconClasses(creative) {

				let classes = {
					selected: Creative.SelectedCreative?.id === creative.id
				};


				if (Layout.page === 'playables') {

					classes.hidden = creative.Tags['hidden'];
					classes.dev = !creative.Tags['released'];

				}

				return classes;

			},
			getCreativeIconStyles(creative) {

				//Файлы креативов лежат на ноде паблишера креатива: путь дополняем адресом этой ноды
				//(Creative.getFileUrl), иначе браузер запросил бы иконку у ноды загрузки клиента
				let version = Creative.CreativesIconsTimes[creative.id] ? '?v=' + Creative.CreativesIconsTimes[creative.id] : '';

				if (creative.options.iconUrl) {

					return {
						backgroundImage: `url(${Creative.getFileUrl(creative, creative.options.iconUrl)}${version})`
					};

				} else if (creative.type === 'playable') {

					if (creative.templateProps) {

						return {
							backgroundImage: `url(${Creative.getFileUrl(creative, `/Images/Icons/Playables/${creative.templateProps.codename.replace(':', '-')}.png`)}${version})`
						};

					} else {

						return {
							backgroundImage: `url(${Creative.getFileUrl(creative, `/Images/Icons/Projects/${creative.codename}.png`)}${version})`
						};

					}

				} else if (Layout.page === 'end-cards') {

					return {
						backgroundImage: `url(${Creative.getFileUrl(creative, `/Images/Icons/EndCards/${creative.templateProps.codename}.png`)})`
					};

				}

			},
			getFilterForOnlineUsers(creativeId) {

				return userData => User.getLastActiveVersionData(userData).creativeId === creativeId;

			},
			addCreative() {

				if (Layout.page === 'playables') Broadcast.call("Show PlayableCreate");
				else if (Layout.page === 'banners') Broadcast.call("Show BannerCreateCreative");
				else if (Layout.page === 'end-cards') Broadcast.call("Show EndCardCreate");
				else if (Layout.page === 'storyboards') Broadcast.call("Show StoryboardCreateCreative");
				else if (Layout.page === 'editable-playables') Broadcast.call("Show EditablePlayableCreateCreative");

			},
			onCreativeOver(creative, e) {

				let el = e.currentTarget;

				Broadcast.call("Show Creative Preview", [creative, e, el]);

			},
			onCreativeOut(creative, e, el) {

				Broadcast.call("Hide Creative Preview", [creative, e, el]);

			},
			dispatchScrollEvent() {

				Broadcast.call("Creatives Plane Scroll");

			}
		}
	}
</script>

<style lang="sass">

	.creatives-plane
		width: 60px
		height: 100%
		text-align: center
		background-color: #343b41
		border-right: 1px solid #23282c
		position: absolute
		left: 0
		top: 0
		overflow: hidden
		z-index: 1

		.creatives-plane-inner
			overflow-y: auto
			width: 100px
			height: 100%

		.creative
			width: 58px
			height: 84px
			display: flex
			align-items: center
			justify-content: center
			position: relative

			.creative-icon
				background: center / 100% no-repeat
				width: 50px
				height: 76px
				border-radius: 5px
				cursor: pointer
				border: 2px solid transparent
				image-rendering: -webkit-optimize-contrast

				&.selected
					border: 2px solid cornsilk
					border-radius: 3px

				&.dev
					opacity: 0.9

				&.hidden
					opacity: 0.1

			.creative-online
				display: flex
				position: absolute
				left: 5px
				width: 48px
				bottom: -3px
				height: 20px
				pointer-events: none

				.online-users-local
					flex-direction: row-reverse

					.user-content
						max-width: 15px

						.user-photo
							border: 1px solid rgba(255, 255, 255, 0.5)
							left: auto
							right: 0

							.c-avatar-status
								display: none

						.additional-users-count
							padding-top: 1px
		.creative.add
			height: 50px

			.creative-add-icon
				color: #f3f4f5
				width: 40px
				height: 30px
				font-size: 20px
				cursor: pointer
				margin-left: 2px

				&:hover
					color: #20a8d8

</style>

